<template>
  <div class="flex justify-between mb-6 lg:flex-row min-[320px]:flex-col">
    <div class="flex gap-2 justify-center items-center">
      <p class="text-neutral-400 text-base font-normal mr-2">{{ LL.filter() }}:</p>
      <div class="flex gap-2 flex-wrap">
        <Rank :rank="Ranks.Entry" />
        <Rank :rank="Ranks.Junior" />
        <Rank :rank="Ranks.Middle" />
        <Rank :rank="Ranks.Senior" />
        <Rank :rank="Ranks.Expert" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Rank from "../Rank/index.vue";
import { typesafeI18n } from "~/locales/i18n-vue";
import Ranks from "@/constants/ranks";

const { LL } = typesafeI18n();
</script>
